"use strict";

const app = {
  settings: {},
  vars: {
    $win: $(window),
    $doc: $(document),
    $html: $('html'),
    $body: $('body'),
    breakpoints: {
      mobile: 320,
      mobileLandscape: 480,
      tablet: 740,
      desktopAd: 810,
      tabletLandscape: 906,
      desktop: 980,
      desktopEx: 1025,
      wide: 1200,
      full: 1480,
      design: 1600,
      screen: 1700,
      hd: 1890
    }
  },
  init: function () {
    this.initGlobalExtensions();
    this.initLocalExtensions($('body'));
  },
  parse: function ($context) {
    this.initLocalExtensions($context);
  },
  initGlobalExtensions: function () {
    var t = this;
    for (var globalExt in t.globalExt) {
      if (!app.obj[globalExt]) {
        app.obj[globalExt] = new t.globalExt[globalExt]();
      }
    }
  },
  initLocalExtensions: function ($context) {
    var t = this;
    for (var ext in t.ext) {
      var $els = $context.findOrSelf('.js-' + ext);
      $els.each(function () {
        var fn = new t.ext[ext]($(this));
        $(this).data('obj_' + ext, fn);
        if (app.obj[ext] === undefined) app.obj[ext] = [];
        if ($(this).data('objectName')) {
          app.obj[ext][$(this).data('objectName')] = fn;
        } else {
          app.obj[ext].push(fn);
        }
      });
    }
  },
  ext: {},
  globalExt: {},
  obj: {}
};
var translate = function (key) {
  const script = document.getElementById('project-config');
  const projectConfig = JSON.parse(script.textContent);
  const translations = projectConfig.translations;
  return translations[key] || key;
};
var swiperA11yOptions = {
  enabled: true
};
Object.assign(swiperA11yOptions, translate('slider'));
$(() => {
  app.init();
});
$.fn.findOrSelf = function (selector) {
  return this.find(selector).add(this.filter(selector));
};
app.globalExt["browser"] = function () {
  var api = {};
  var $html = app.vars.$html;
  var $body = app.vars.$body;
  var states = {
    browser: "page--browser-open"
  };

  // Cookies Options
  var $browserToggle = $(".js-browser-toggle");
  var init = function () {
    addListeners();
    browserCheck();
  };

  //listeners
  var addListeners = function () {
    //close modal on okay or cross icon
    $browserToggle.on("click", browserAccept);
  };

  //check browsers
  var browserCheck = function () {
    if (Cookies.get("browser-awared") === undefined) {
      var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;
      var fullVersion = "" + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);
      majorVersion = parseInt("" + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      // console.log(browserName);
      // console.log(majorVersion);

      if (browserName === "Netscape" && majorVersion <= 5) {
        // IE11 == Netscape 5
        browserAware();
      } else if (browserName === "Microsoft Internet Explorer" && majorVersion <= 11) {
        //IE10 and lower, but may be it will check IE11 as IE so let it <11
        browserAware();
      } else if (browserName === "Chrome" && majorVersion < 66) {
        browserAware();
      } else if (browserName === "Firefox" && majorVersion <= 59) {
        browserAware();
      } else if (browserName === "Edge" && majorVersion <= 16) {
        //detects as Chrome. Edge 15 == Chrome 52

        browserAware();
      } else if (browserName === "Safari" && majorVersion < 11) {
        browserAware();
      }
    }
  };

  //show modal function
  var browserAware = function () {
    setTimeout(() => {
      $html.toggleClass(states.browser);
    }, 2000);
  };

  //close modal function
  var browserAccept = function () {
    if (Cookies.get("browser-awared") === undefined) {
      Cookies.set("browser-awared", true, {
        expires: 365
      });
    }
    $html.toggleClass(states.browser);
  };
  init();
  return api;
};

// app.globalExt["cookies"] = function () {
//   var api = {};

//   var $html = app.vars.$html;

//   var states = {
//     cookies: "page--cookies-open",
//     options: "page--cookies-options-open",
//   };

//   // Cookies Options
//   var $cookiesOptions = $(".js-cookies-options");
//   var $cookiesOptionsOpen = $(".js-cookies-options-open");
//   var $cookiesOptionsClose = $(".js-cookies-options-close");

//   // Cookies options
//   var $inputs = $(".js-cookies-checkbox");

//   // Cookie options
//   var $all = $(".js-cookies-option-all");
//   var $service = $(".js-cookies-option-service");
//   var $marketing = $(".js-cookies-option-marketing");

//   // Accept buttons (two)
//   var $accept = $(".js-cookies-accept");

//   const optionsModal = createFocusTrap($cookiesOptions[0], {
//     onDeactivate: () => $html.removeClass(states.options),
//   });

//   var init = function () {
//     addListeners();

//     if (Cookies.get("cookies-loop-accepted") === undefined) {
//       setTimeout(() => {
//         bannerToggle();
//         $all.prop("checked", true); //set all to true (by default), so checker can seе the cookies
//         allOptionsCheck();
//       }, 3000);
//     }

//     if (Cookies.get("cookies-loop-accepted") === "true") {
//       cookiesInit();
//     }

//     // checkbox clickers
//     allCheckboxUpdate();
//     checkboxUpdate();
//   };

//   var addListeners = function () {
//     $cookiesOptionsOpen.on("click", openOptionsModal);
//     $cookiesOptionsClose.on("click", closeOptionsModal);

//     $accept.on("click", cookiesInit);
//   };

//   // TOGGLE OPTIONS MODAL
//   var openOptionsModal = function () {
//     $html.addClass(states.options);
//     optionsModal.activate();
//   };

//   var closeOptionsModal = optionsModal.deactivate;

//   // TOOGLE COOKIES BOTTOM BANNER
//   var bannerToggle = function () {
//     $html.toggleClass(states.cookies);
//   };

//   // ALL OPTIONS CHECKER
//   var allOptionsCheck = function () {
//     if ($all.prop("checked")) {
//       $service.prop("checked", true);
//       $marketing.prop("checked", true);
//       Cookies.set("cookies-loop-service", true, { expires: 365 });
//       Cookies.set("cookies-loop-marketing", true, { expires: 365 });
//     } else {
//       $service.prop("checked", false);
//       $marketing.prop("checked", false);
//       Cookies.set("cookies-loop-service", false, { expires: 365 });
//       Cookies.set("cookies-loop-marketing", false, { expires: 365 });
//     }
//   };

//   // SINGLE OPTIONS CHECKERS
//   var optionsCheck = function () {
//     if ($service.prop("checked") && $marketing.prop("checked")) {
//       $all.prop("checked", true);
//     }

//     if (!$service.prop("checked") || !$marketing.prop("checked")) {
//       $all.prop("checked", false);
//     }

//     if ($service.prop("checked")) {
//       Cookies.set("cookies-loop-service", true, { expires: 365 });
//     } else {
//       Cookies.set("cookies-loop-service", false, { expires: 365 });
//     }

//     if ($marketing.prop("checked")) {
//       Cookies.set("cookies-loop-marketing", true, { expires: 365 });
//     } else {
//       Cookies.set("cookies-loop-marketing", false, { expires: 365 });
//     }
//   };

//   // INIT COOKIES FUNCTIONS
//   var cookiesInit = function () {
//     //close all modals
//     if (Cookies.get("cookies-loop-accepted") === undefined) {
//       // console.log('cookiesaccepted === undef');
//       // set that cookies has been accepted
//       Cookies.set("cookies-loop-accepted", true, { expires: 365 });
//     }

//     closeOptionsModal();

//     if ($html.hasClass(states.cookies)) {
//       bannerToggle();
//     }

//     //remove checked checkboxes for false
//     if (Cookies.get("cookies-loop-service") === "false") {
//       $all.prop("checked", false);
//       $service.prop("checked", false);
//     }

//     if (Cookies.get("cookies-loop-marketing") === "false") {
//       $all.prop("checked", false);
//       $marketing.prop("checked", false);
//     }

//     //run essential cookies (always)
//     // console.log("essential functions init");
//     runEssential();

//     //run service cookies
//     if (
//       $service.prop("checked") &&
//       Cookies.get("cookies-loop-service") === "true"
//     ) {
//       runService();
//     }

//     //run marketing cookies
//     if (
//       $marketing.prop("checked") &&
//       Cookies.get("cookies-loop-marketing") === "true"
//     ) {
//       runMarketing();
//     }
//   };

//   // SINGLE CHECKBOXES EVENTS
//   var allCheckboxUpdate = function () {
//     $all.on("click", allOptionsCheck);
//   };

//   var checkboxUpdate = function () {
//     $inputs.on("click", optionsCheck);
//   };

//   // COOKIES FUNCTIONS
//   var runEssential = function () {
//     //essential cookies functions goes here
//   };

//   var runService = function () {
//     //service cookies functions goes here
//   };

//   var runMarketing = function () {
//     //marketing cookies functions goes here
//     if (
//       $(".js-cookies").data("track") ||
//       document.querySelector(".js-cookies").dataset.track !== undefined
//     ) {
//       triggerGATracking();
//     }
//   };

//   var triggerGATracking = function () {
//     window.dataLayer = window.dataLayer || [];
//     function gtag() {
//       window.dataLayer.push(arguments);
//     }
//     gtag("consent", "default", {
//       ad_personalization: "denied",
//       ad_storage: "denied",
//       ad_user_data: "denied",
//       analytics_storage: "denied",
//       functionality_storage: "denied",
//       personalization_storage: "denied",
//       security_storage: "granted",
//       wait_for_update: 500,
//     });

//     if (window.location.pathname.indexOf("/de/fischapark") >= 0) {
//       (function (w, d, s, l, i) {
//         w[l] = w[l] || [];
//         w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
//         var f = d.getElementsByTagName(s)[0],
//           j = d.createElement(s),
//           dl = l != "dataLayer" ? "&l=" + l : "";
//         j.async = true;
//         j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
//         f.parentNode.insertBefore(j, f);
//       })(window, document, "script", "dataLayer", "GTM-TPTGVJ8");
//     }

//     if (typeof document.body.dataset["gtm"] !== "undefined") {
//       (function (w, d, s, l, i) {
//         w[l] = w[l] || [];
//         w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
//         var f = d.getElementsByTagName(s)[0],
//           j = d.createElement(s),
//           dl = l != "dataLayer" ? "&l=" + l : "";
//         j.async = true;
//         j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
//         f.parentNode.insertBefore(j, f);
//       })(window, document, "script", "dataLayer", document.body.dataset["gtm"]);
//     }
//   };

//   init();
//   return api;
// };

app.globalExt['global-structure'] = function () {
  var api = {};
  var init = function () {};
  init();
  return api;
};
app.globalExt['lazy-loading'] = function () {
  var api = {};
  var init = function () {
    Modernizr.on('webp', function (result) {
      if (false && result) {
        convert_images('.webp');
      } else {
        // Modernizr.on('jpeg2000', function(result) {
        // 	if (result) {
        // 		convert_images('.jpeg2000');
        // 	} else {
        convert_images(false);
        //		}
        // });
      }
    });
  };
  var convert_images = function (format) {
    if (format) {
      $('.lazy[data-src]').each(function () {
        let dataSrc = $(this).data('src');
        if (dataSrc && (dataSrc.endsWith(".jpg") || dataSrc.endsWith(".jpeg") || dataSrc.endsWith(".png"))) {
          $(this).attr('data-src', dataSrc + format);
        }
      });
      $('.lazy[data-background-image]').each(function () {
        let dataSrc = $(this).data('background-image');
        if (dataSrc && (dataSrc.endsWith(".jpg") || dataSrc.endsWith(".jpeg") || dataSrc.endsWith(".png"))) {
          $(this).attr('data-src', dataSrc + format);
        }
      });
    }
    app.vars.observer = lozad('.lazy', {
      loaded: function (el) {
        // Custom implementation on a loaded element
        el.classList.add('loaded');
      }
    });
    app.vars.observer.observe();
  };
  document.addEventListener('observe-lazyload', function (e) {
    app.vars.observer.observe();
  });
  init();
  return api;
};
app.ext["alert"] = function ($el) {
  var api = {};
  var $body = app.vars.$body;
  var $win = app.vars.$win;
  var init = function () {
    var api_url = $el.data('api-url');
    console.log(api_url);
    if (api_url === '') {
      return;
    }
    $.ajax({
      url: api_url
    }).done(function (data) {
      if (data) {
        $body.addClass('is-fixed');
        $el.html(data);
        $el.removeClass('is-hidden');
        $el.find('.js-darkpage-topbar-close').on('click', function () {
          $el.find('.js-darkpage-topbar').slideUp('250');
          $el.find('.js-darkpage-content').addClass('no-topbar');
        });
        $('.js-darkpage-faqs-trigger').on('click', function () {
          var $this = $(this);
          var $item = $this.parent('.js-darkpage-faqs-item');
          if (!$item.hasClass('is-collapsed')) {
            $('.js-darkpage-faqs-item.is-collapsed .js-darkpage-faqs-content').slideUp(250);
            $('.js-darkpage-faqs-item.is-collapsed').removeClass('is-collapsed');
            $item.addClass('is-collapsed');
            $item.find('.js-darkpage-faqs-content').slideDown(250);
          } else {
            $item.removeClass('is-collapsed');
            $item.find('.js-darkpage-faqs-content').slideUp(250);
          }
        });
        app.vars.observer.observe();
      } else {
        $el.remove();
      }
    });
  };
  init();
  return api;
};
app.ext['blog-back'] = function ($el) {
  var api = {};
  var init = function () {
    addListeners();
  };
  var addListeners = function () {
    $el.on("click", previousPage);
  };
  var previousPage = function () {
    var oldUrl = document.referrer;
    if (!oldUrl) {
      window.open('/', '_self');
    } else {
      window.open(oldUrl, '_self');
    }
  };
  init();
  return api;
};
app.ext["blog-overview"] = function ($el) {
  var api = {};
  var $pagination = $el.find(".js-blog-overview-pagination");
  var $paginationItems = $pagination.find(".js-blog-overview-page");
  var $filterRadioInputs = $el.find(".js-blog-overview-filter");
  var $container = $el.find(".js-blog-overview-container");
  var $page_index = $pagination.find(".js-blog-overview-page.is-active").data("page-index");
  var $prevEllipsis = $el.find(".js-blog-overview-ellipsis-prev");
  var $nextEllipsis = $el.find(".js-blog-overview-ellipsis-next");
  var $btnNext = $pagination.find(".js-blog-overview-next");
  var $btnPrev = $pagination.find(".js-blog-overview-prev");
  const maxPaginationVisibleDesktop = 5;
  const maxPaginationVisibleMobile = 4;
  var maxPaginationVisible = maxPaginationVisibleMobile;
  var offset = 2;
  var init = function () {
    add_event_listeners();
    onResize();
  };
  var add_event_listeners = function () {
    $pagination.on("click", ".js-blog-overview-page", page_click);
    $pagination.on("click", ".js-blog-overview-next", next_page_click);
    $pagination.on("click", ".js-blog-overview-prev", prev_page_click);
    $filterRadioInputs.on("change", onFilterChange);
    $(window).on('resize', onResize);
  };
  var onResize = function () {
    if (window.innerWidth < 490) {
      maxPaginationVisible = maxPaginationVisibleMobile;
      offset = 1;
    } else {
      maxPaginationVisible = maxPaginationVisibleDesktop;
      offset = 2;
    }
    hidePaginationItems();
  };
  var next_page_click = function (e) {
    e.preventDefault();
    e.stopPropagation();
    $page_index++;

    // var $page_index = $pagination
    //   .find(".js-blog-overview-page.is-active")
    //   .data("page-index");

    load_articles($page_index, false);
  };
  var prev_page_click = function (e) {
    e.preventDefault();
    e.stopPropagation();
    $page_index--;
    load_articles($page_index, false);
  };
  var page_click = function (e) {
    e.preventDefault();
    e.stopPropagation();
    $page_index = $(this).data("page-index");
    load_articles($page_index, false);
  };
  var onFilterChange = function (e) {
    $page_index = 0;
    $filterRadioInputs.parent().removeClass("is-active");
    $(this).parent().addClass("is-active");
    load_articles($page_index, true);
    hidePaginationItems();
  };
  var hidePaginationItems = function () {
    // pagination gets replaced
    $pagination = $el.find(".js-blog-overview-pagination");
    $paginationItems = $pagination.find(".js-blog-overview-page");
    $prevEllipsis = $el.find(".js-blog-overview-ellipsis-prev");
    $nextEllipsis = $el.find(".js-blog-overview-ellipsis-next");
    let totalPages = $paginationItems.length;
    let startPage = Math.max(0, $page_index - offset);
    let endPage = Math.min(totalPages - 1, $page_index + offset);
    if (endPage - startPage <= maxPaginationVisible) {
      if (startPage === 0) {
        endPage = Math.min(maxPaginationVisible - 1, totalPages - 1);
      } else if (endPage === totalPages - 1) {
        startPage = Math.max(totalPages - maxPaginationVisible, 0);
      }
    }
    $paginationItems.each(function () {
      let pageIndex = $(this).data("page-index");
      if (pageIndex >= startPage && pageIndex <= endPage) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    if (startPage > 0) {
      $prevEllipsis.show();
    } else {
      $prevEllipsis.hide();
    }
    if (endPage < totalPages - 1) {
      $nextEllipsis.show();
    } else {
      $nextEllipsis.hide();
    }
  };
  var load_articles = function (page_index, filter_change) {
    var api_url = $el.data("api-url");
    var category = $filterRadioInputs.filter(":checked").data("slug");

    // console.log($filterRadioInputs.filter(":checked"))

    // TODO - show loader

    $.ajax({
      method: "POST",
      url: api_url,
      data: {
        page_index: page_index,
        category: category,
        filter_change: filter_change
      }
    }).done(response => {
      var response_json = JSON.parse(response);
      // TODO - hide loader

      $container.html(response_json["articles"]);
      app.vars.observer.observe();
      $pagination.find(".js-blog-overview-page.is-active").removeClass("is-active");
      $pagination.find(".js-blog-overview-page[data-page-index=" + page_index + "]").addClass("is-active");
      if (!filter_change) {
        $("html, body").animate({
          scrollTop: $el.offset().top - 40
        }, 250);
      } else {
        $pagination.html(response_json["pagination"]);
      }
      hidePaginationItems();
      manage_prev_next_availability();
    });
  };
  var manage_prev_next_availability = function () {
    $btnNext = $pagination.find(".js-blog-overview-next");
    $btnPrev = $pagination.find(".js-blog-overview-prev");
    if ($page_index === 0) {
      $btnPrev.addClass("disabled");
    } else {
      $btnPrev.removeClass("disabled");
    }
    if ($page_index === $paginationItems.length - 1) {
      $btnNext.addClass("disabled");
    } else {
      $btnNext.removeClass("disabled");
    }
  };
  init();
  return api;
};
app.ext['center-select'] = function ($el) {
  var api = {};

  //THIS WORKS ONLY FOR MOBILE
  //FOR DESKTOP IT USES SELECTRIC IN THE HEADER.JS

  var init = function () {
    centerSelect();
  };
  var centerSelect = function () {
    $el.on('change', function () {
      var url = $(".js-center-option:selected").attr("data-url"); // get selected value
      console.log(url);
      if (url) {
        // require a URL
        window.location = url; // redirect
      }
      return false;
    });
  };
  init();
  return api;
};
app.ext['download-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-download-swiper-container');
  var $pagination = $el.find('.js-download-swiper-pagination');
  var $prev = $el.find('.js-download-swiper-prev');
  var $next = $el.find('.js-download-swiper-next');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          centeredSlides: true
        },
        // desktop when its more than 3 items
        1200: {
          slidesPerView: 3
        }
      },
      spaceBetween: 22,
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext["footer"] = function ($el) {
  var api = {};
  var $html = app.vars.$html;
  var classes = {
    timetable: ".js-time-toggle",
    langselect: ".js-lang-select"
  };
  var states = {
    timetable: "page--time-open"
  };
  var $timeToggle = $el.find(classes.timetable);
  var $langSelect = $el.find(classes.langselect);
  var init = function () {
    addListeners();
    init_custom_select();
  };
  var addListeners = function () {
    $timeToggle.on("click", timeTableToggle);
  };
  var timeTableToggle = function (e) {
    $html.toggleClass(states.timetable);
  };
  var init_custom_select = function () {
    $langSelect.selectric({
      responsive: true,
      arrowButtonMarkup: '<b class="button"></b>',
      optionsItemBuilder: function (itemData) {
        var $opt_el = itemData.element;
        return '<div class="" data-url="' + $opt_el.data("url") + '">' + itemData.text + "</div>";
      },
      onChange: function () {
        //THIS WORKS ONLY FOR DESKTOP AS IT USES SELECTRIC
        //FOR MOBILE IT USES LANG-SELECT.JS
        var url = $el.find(".js-lang-option.selected div").attr("data-url"); // get selected value

        if (url) {
          // require a URL
          window.location = url; // redirect
        }
        return false;
      }
    });
  };
  init();
  return api;
};
app.ext['header'] = function ($el) {
  var api = {};
  var $win = app.vars.$win;
  var $html = app.vars.$html;
  var $doc = app.vars.$doc;
  var classes = {
    toggle: '.js-nav-toggle',
    timetable: '.js-time-toggle',
    openingStatus: '.js-async-time-toggle',
    centerselect: '.js-center-select',
    langselect: '.js-lang-select'
  };
  var states = {
    open: 'page--nav-open',
    timetable: 'page--time-open',
    scroll: 'page--nav-scroll',
    statusOpened: 'is-opened',
    statusClosed: 'is-closed'
  };
  var $mobileMenu = $el.find('.js-nav-mobile-menu');

  // Hide Header on on scroll down
  var deviceWidth = $win.outerWidth();
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $el.outerHeight();
  var $toggle = $el.find(classes.toggle);
  var $timeToggle = $el.find(classes.timetable);
  var $timeToggleTarget = $('#' + $timeToggle.attr('aria-controls'));
  var $openingStatus = $el.find(classes.openingStatus);
  var $centerSelect = $el.find(classes.centerselect);
  var $langSelect = $el.find(classes.langselect);
  const mobileMenuFocusTrap = createFocusTrap($el[0], {
    onDeactivate: onMobileMenuClose,
    initialFocus: (_, focusableElements) => focusableElements.find(el => $mobileMenu[0].contains(el))
  });
  var init = function () {
    addListeners();
    checkOpeningState();

    // Matej selectric
    init_custom_select();
  };
  var addListeners = function () {
    $timeToggle.on('click', timeTableToggle);
    $toggle.on('click.nav-toggle', toggleMobileMenu);

    // when esc key is pressed close everything
    $doc.on('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if ($html.hasClass(states.open)) {
        onMobileMenuClose();
      }
      if ($html.hasClass(states.timetable)) {
        timeTableToggle();
      }
    });
    if (deviceWidth > 1200) {
      $win.on('scroll', scroll);
    }
  };
  var checkOpeningState = async function () {
    // TODO: remove local
    const api = window.location.href.indexOf('local') >= 0 || window.location.href.indexOf('template') >= 0 ? '/api/opening-hours.php' : document.body.dataset.baseurl + '/api/opening-hours';
    try {
      const response = await fetch(api);

      // Check if the response status is OK (200)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Wait for the response to be fully read as JSON
      const data = await response.json();
      const open = parseInt(data.data.status) === 1;
      $openingStatus.each(function () {
        $(this).parent().addClass(open ? states.statusOpened : states.statusClosed);
        $(this).find('.js-async-status').text(open ? $(this).data('openlabel') : $(this).data('closedlabel'));
        $(this).css('opacity', 1);
        $(this).css('visibility', 'visible');
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  var timeTableToggle = function () {
    $html.toggleClass(states.timetable);
    $timeToggle.attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
    $timeToggleTarget.attr('aria-hidden', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
  };
  function openMobileMenu() {
    $html.addClass(states.open);
    mobileMenuFocusTrap.activate();
    $mobileMenu.removeAttr('inert');
    $toggle.attr('aria-expanded', 'true');
  }
  function onMobileMenuClose() {
    $html.removeClass(states.open);
    $mobileMenu.attr('inert', '');
    $toggle.attr('aria-expanded', 'false');
  }
  var toggleMobileMenu = function (e) {
    $html.hasClass(states.open) ? mobileMenuFocusTrap.deactivate() : openMobileMenu();
  };
  var scroll = function () {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $html.addClass(states.scroll);
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $html.removeClass(states.scroll);
      }
    }
    lastScrollTop = st;
  };
  var init_custom_select = function () {
    $centerSelect.selectric({
      responsive: true,
      arrowButtonMarkup: '<b class="button"></b>',
      labelBuilder: function (curritem) {
        var $curr_el = curritem.element;
        return '<span class="text--highlight"><span class="text--boldest">' + curritem.value + '</span>, ' + $curr_el.data('location') + '</span>';
      },
      optionsItemBuilder: function (itemData) {
        var $opt_el = itemData.element;
        return '<div data-url="' + $opt_el.data('url') + '"><span><span class="text--boldest">' + itemData.text + '</span>, ' + $opt_el.data('location') + '</span></div>';
      },
      onChange: function () {
        //THIS WORKS ONLY FOR DESKTOP AS IT USES SELECTRIC
        //FOR MOBILE IT USES CENTER-SELECT.JS
        var url = $('.js-center-option.selected div').attr('data-url'); // get selected value
        console.log(url);
        if (url) {
          // require a URL
          window.location = url; // redirect
        }
        return false;
      }
    });
    $langSelect.selectric({
      responsive: true,
      arrowButtonMarkup: '<b class="button"></b>',
      optionsItemBuilder: function (itemData) {
        var $opt_el = itemData.element;
        return '<div class="js-lang-option" data-url="' + $opt_el.data('url') + '">' + itemData.text + '</div>';
      },
      onChange: function () {
        //THIS WORKS ONLY FOR DESKTOP AS IT USES SELECTRIC
        //FOR MOBILE IT USES LANG-SELECT.JS
        var url = $('.js-lang-option.selected div').attr('data-url'); // get selected value
        console.log(url);
        if (url) {
          // require a URL
          window.location = url; // redirect
        }
        return false;
      }
    });
  };

  /**
   * FOCUS TRAP
   */

  function isElementVisible(element) {
    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  /**
   * @param {Element} container
   */
  function getFocusableElements(container) {
    const not = {
      inert: ':not([inert]):not([inert] *)',
      negativeTabIndex: ':not([tabindex^="-"])',
      disabled: ':not(:disabled)'
    };
    const FOCUSABLE_ELEMENTS_SELECTOR = [`a[href]${not.inert}${not.negativeTabIndex}`, `area[href]${not.inert}${not.negativeTabIndex}`, `input:not([type="hidden"]):not([type="radio"])${not.inert}${not.negativeTabIndex}${not.disabled}`, `input[type="radio"]${not.inert}${not.negativeTabIndex}${not.disabled}`, `select${not.inert}${not.negativeTabIndex}${not.disabled}`, `textarea${not.inert}${not.negativeTabIndex}${not.disabled}`, `button${not.inert}${not.negativeTabIndex}${not.disabled}`, `details${not.inert} > summary:first-of-type${not.negativeTabIndex}`,
    // Discard until Firefox supports `:has()`
    // See: https://github.com/KittyGiraudel/focusable-selectors/issues/12
    // `details:not(:has(> summary))${not.inert}${not.negTabIndex}`,
    `iframe${not.inert}${not.negativeTabIndex}`, `audio[controls]${not.inert}${not.negativeTabIndex}`, `video[controls]${not.inert}${not.negativeTabIndex}`, `[contenteditable]${not.inert}${not.negativeTabIndex}`, `[tabindex]${not.inert}${not.negativeTabIndex}`].join(',');
    return Array.from(container.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR)).filter(isElementVisible);
  }
  function createFocusTrap(container, options = {}) {
    let previouslyFocusedElement = null;
    let focusableElements = null;
    const trap = {
      activate,
      deactivate
    };
    return trap;
    function activate() {
      previouslyFocusedElement = document.activeElement;
      requestAnimationFrame(() => {
        focusableElements = getFocusableElements(container);
        if (options.initialFocus) {
          options.initialFocus(container, focusableElements).focus();
        } else {
          focusableElements[0].focus();
        }
      });
      document.addEventListener('keydown', handleKeydown);
      requestAnimationFrame(() => document.addEventListener('click', handleClick));
    }
    function deactivate() {
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('click', handleClick);
      if (options.onDeactivate) {
        options.onDeactivate();
      }
      if (previouslyFocusedElement) {
        previouslyFocusedElement.focus();
      }
    }
    function handleKeydown(event) {
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      switch (event.key) {
        case 'Tab':
          if (event.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              event.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              event.preventDefault();
              firstFocusableElement.focus();
            }
          }
          break;
        case 'Escape':
          deactivate();
          break;
      }
    }
    function handleClick(event) {
      if (!container.contains(event.target)) {
        deactivate();
      }
    }
  }
  init();
  return api;
};
app.ext['hero-video'] = function ($el) {
  var api = {};
  var $pauseButton = $el.find('.js-hero-video__control');
  var $pauseIcon = $el.find('.js-hero-video__control-pause');
  var $playIcon = $el.find('.js-hero-video__control-play');
  var $heroVideo = $el.find('.js-hero-video__video');
  var init = function () {
    $playIcon.hide();
    $pauseButton.on('click', function () {
      console.log('heroVideo', $heroVideo);
      if (!$heroVideo.length) return;
      if ($heroVideo[0].paused) {
        $heroVideo[0].play();
        $pauseIcon.show();
        $playIcon.hide();
        $pauseButton.attr('aria-pressed', 'false');
      } else {
        $heroVideo[0].pause();
        $pauseIcon.hide();
        $playIcon.show();
        $pauseButton.attr('aria-pressed', 'true');
      }
    });
  };
  init();
  return api;
};
app.ext['image-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-image-swiper-swiper');
  var $pagination = $el.find('.js-image-swiper-pagination');
  var $prev = $el.find('.js-image-swiper-prev');
  var $next = $el.find('.js-image-swiper-next');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        440: {
          slidesPerView: 2
        },
        // when window width is >= 640px
        890: {
          slidesPerView: 'auto'
        }
      },
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext['lang-select'] = function ($el) {
  var api = {};

  //THIS WORKS ONLY FOR MOBILE
  //FOR DESKTOP IT USES SELECTRIC IN THE HEADER.JS AND FOOTER.JS

  var init = function () {
    langSelect();

    // hide the select element from screen readers
    $el.parent().siblings('.selectric-input').attr('aria-hidden', 'true');
    var $selectricWrapper = $el.parent().parent();
    var $ul = $selectricWrapper.find('ul');
    var $input = $selectricWrapper.find('input');
    $input.attr('aria-label', $el.attr('aria-label'));
    $selectricWrapper.attr('aria-label', $el.attr('aria-label'));
    $ul.attr('aria-label', $el.attr('aria-label'));

    // give the ul a role of listbox and all li elements a role of option
    $ul.attr('role', 'listbox');
    $ul.find('li').attr('role', 'option');
  };
  var langSelect = function () {
    $el.on('change', function () {
      var url = $('.js-lang-option:selected').attr('data-url'); // get selected value
      console.log(url);
      if (url) {
        // require a URL
        window.location = url; // redirect
      }
      return false;
    });
  };
  init();
  return api;
};
app.ext['local-structure'] = function ($el) {
  var api = {};
  var init = function () {};
  init();
  return api;
};
app.ext['locations-grid-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-locations-grid-swiper-container');
  var $pagination = $el.find('.js-locations-grid-swiper-pagination');
  var $prev = $el.find('.js-locations-grid-swiper-prev');
  var $next = $el.find('.js-locations-grid-swiper-next');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext['partybooking'] = function ($el) {
  var api = {};
  var $partybooking = $('.js-partybooking');
  var $edit_step = $('.js-changestep');
  var $step = $('.js-partybooking-step');
  var $all_steps = $('.partybooking__step');
  var $step_back = $('.js-partybooking-back');
  var $step_dropdown = $('.js-partybooking-stepselection .js-step');
  var $cal = $('.js-partybooking-cal');
  var $partytime = $('.js-partytime');
  var $partytheme_step = $('.js-partytheme-step');
  var $step_selector = $('.js-partybooking-stepselector');
  var $step_selection = $('.js-partybooking-stepselection');
  var current_step = 0;
  var current_price = 0;
  var cake_price = 0;

  // booking varialbes
  var partytime = false;
  var partydate = false;
  var kids_count = 1;
  var kids_age = false;
  var partytheme = false;
  var partyroom = false;
  var partyroom_id = false;
  var food_enabled = true;
  var food_cake = false;
  var food_meal = new Object();
  var food_snacks = new Object();
  var selffood = false;
  var themefood = false;
  var partyextras = new Object();
  var care_included = false;
  var translations = new Object();
  var default_kids_count = Number($el.attr('data-count-defaultkids'));
  var extra_kid_price_happyhour = Number($el.attr('data-price-extrakids-happyhour'));
  var extra_kid_price_default = Number($el.attr('data-price-extrakids'));
  var extra_kid_price = Number($el.attr('data-price-extrakids'));
  var happy_hour = false;
  var exclude_happy_hour_food = Number($el.attr('data-excludehappyhourfood')) === 1 ? true : false;
  var temp_extra_kids_price = 0;
  var theme_surcharge = 0;
  var meal_notavailable = Number($el.attr('data-meal-na')) == 1 ? true : false;
  var initial_meal_included = Number($el.attr('data-meal-included')) == 1 ? true : false;
  var cake_included = false;
  var meal_included = false;
  var meal_price = 0;
  var blog_path = '';
  var pageid = Number($el.attr('data-pageid'));
  var finalurl = $el.attr('data-finalurl');
  var cal_xhr = false;
  var init = function () {
    addListeners();

    // translations
    translations.currency = $('.js-translations').attr('data-translation-currency');
    translations.kids_with_cake = $('.js-translations').attr('data-translation-kids-with-cake');
    translations.kids_without_cake = $('.js-translations').attr('data-translation-kids-without-cake');
    translations.timeslot_gone = $('.js-translations').attr('data-translation-timeslot-gone');
    translations.incl = $('.js-translations').attr('data-translation-incl');

    // jump to step if hash is set
    if (window.location.hash) {
      var h = window.location.hash.replace('#', '');
      if (!isNaN(h)) current_step = h;
      showStep(current_step);
    }

    // init default select boxes
    $('.js-partybooking-select').selectric({
      responsive: true,
      arrowButtonMarkup: '<b class="button"></b>',
      labelBuilder: function (curritem) {
        var $curr_el = curritem.element;
        return curritem.value;
      },
      optionsItemBuilder: function (itemData) {
        var $opt_el = itemData.element;
        return itemData.text;
      }
    });

    // create day picker with deactivated days etc.
    var all_dates = JSON.parse($cal.attr('data-dates'));
    var start_day = $cal.attr('data-mindate');
    var end_day = $cal.attr('data-maxdate');
    var disabled_dates = JSON.parse($partytime.attr('data-disableddates'));
    var center = $partytime.attr('data-center');
    blog_path = $partytime.attr('data-blogpath');
    $(document).on('click', '.pignose-calendar-unit-active', function () {
      console.log('active');
    });
    $cal.pignoseCalendar({
      week: 1,
      disabledDates: disabled_dates,
      initialize: false,
      minDate: start_day,
      //maxDate: end_day,
      disabledWeekdays: [0],
      select: function (date) {
        if (cal_xhr !== false) cal_xhr.abort();
        resetAllData();
        $('.js-partybookingdate-nodates').addClass('hidden');
        if (!happy_hour) current_price -= theme_surcharge;
        let current_meal_price = calcMealPrice();
        if (!initial_meal_included && meal_included && !happy_hour) current_price += current_meal_price;

        // deselect
        if (!date[0]) {
          partydate = false;
          partytime = false;
          $('.js-partybookingdatecol').addClass('hidden');
          if ($partytime.find('.js-partybooking-radio.active').length > 0) {
            current_price -= Number($partytime.find('.js-partybooking-radio.active').attr('data-price'));
            extra_kid_price = extra_kid_price_default;
            checkExtraKids();
            updatePrice();
          }
          $partytime.find('.js-partybooking-radio').remove();

          // select date
        } else {
          var help_data = date[0]._i.split('-');
          partydate = help_data[2] + '.' + help_data[1] + '.' + help_data[0];
          var partydate_query = help_data[0] + '-' + help_data[1] + '-' + help_data[2];
          partytime = false;
          if ($partytime.find('.js-partybooking-radio.active').length > 0) {
            current_price -= Number($partytime.find('.js-partybooking-radio.active').attr('data-price'));
            extra_kid_price = extra_kid_price_default;
            checkExtraKids();
            updatePrice();
          }

          // async load available dates and remove current ones
          $partytime.find('.js-partybooking-radio').remove();
          cal_xhr = $.ajax({
            url: blog_path + 'api/partybooking',
            type: 'post',
            data: {
              date: partydate_query,
              center: center
            },
            dataType: 'json',
            success: function (data) {
              cal_xhr = false;
              if (data.meta.success === true) {
                var counter = 0;
                data.data.forEach(function (d) {
                  counter++;
                  let happyhour = d.happyhour ? 1 : 0;
                  let counterContent = happyhour === 1 ? counter + ' <span>*</span>' : counter;
                  var $e = '<div class="partybooking__input__date js-partybooking-radio" data-grp="partytime" data-value="' + d.label + '" data-price="' + d.price + '" data-happyhour="' + happyhour + '" data-start="' + d.start + '" data-end="' + d.end + '" data-rooms=",' + d.rooms.join(',') + ',"> \
                                    <span class="pre">' + $partytime.attr('data-translation-date') + ' ' + counterContent + '</span><span class="post">' + d.label + '</span> \
                                    </div>';
                  $partytime.append($e);
                });
                $('.js-partybookingdatecol').removeClass('hidden');
              } else {
                $('.js-partybookingdatecol').addClass('hidden');
                $('.js-partybookingdate-nodates').removeClass('hidden');
              }
            }
          });
        }
        nextStepStatus();
      }
    });
  };

  // listeners for different input types
  var addListeners = function () {
    $step.on('click', gotoStep);
    $step_selector.on('click', selectStep);
    $step_dropdown.on('click', function () {
      if (!$(this).hasClass('disabled')) showStep($(this).attr('data-step'));
    });
    $step_back.on('click', function () {
      showStep(current_step - 1, true);
    });
    $(document).on('click', '.js-changestep', function () {
      showStep($('.js-partybooking-step-item[data-check="' + $(this).attr('data-goto') + '"]').first().attr('data-step'));
    });
    $('body').on('click', clickOutside);

    // selffood checkbox
    $('.js-selffood').on('click', function () {
      selffood = !selffood;
      if (selffood) {
        $('.js-selffood').addClass('active');
        $('.js-partybooking-food-elems').addClass('partybooking__foodbar__counter--blocked');

        // remove price from full price when selffood gets activated
        let mealPrice = calcMealPrice();
        current_price -= mealPrice;
        updatePrice();
        food_meal = new Object();
        $('.js-partybooking-food-elems .partybooking__counter').text('0');
        $('.js-partybooking-food-elems .partybooking__counter').attr('data-val', '0');
      } else {
        $('.js-selffood').removeClass('active');
        $('.js-partybooking-food-elems').removeClass('partybooking__foodbar__counter--blocked');
      }
      checkstep('food');
    });

    // submit party and book
    $('.js-partybooking-done').on('click', submitBooking);
    $partytheme_step.on('click', function () {
      // set active states
      $(this).addClass('active');
      $(this).siblings('.js-partybooking-radio.active').click();

      // jump to next substep
      $('.js-partytheme-step1').addClass('hidden');
      $('.js-partytheme-step2').removeClass('hidden');
    });

    // radio selection
    $(document).on('click', '.js-partybooking-radio', function () {
      var grp = $(this).data('grp');
      if ($(this).hasClass('active')) {
        // remove active cake
        if (grp == 'food_cake') {
          cake_price = Number($(this).attr('data-price'));
          if (!cake_included) current_price -= cake_price * 1;
          cake_price = 0;
        } else if (grp == 'partytime') {
          if (!happy_hour) current_price -= theme_surcharge;
          current_price -= Number($partytime.find('.js-partybooking-radio.active').attr('data-price'));
          extra_kid_price = extra_kid_price_default;
          checkExtraKids();
          let current_meal_price = calcMealPrice();
          if (!initial_meal_included && meal_included && (!happy_hour || happy_hour && exclude_happy_hour_food)) current_price += current_meal_price;

          // also remove partyroom
          hideRooms(false);
          deactivateRoom();
          resetExtras();
          resetAllData();
          showHideExtras(0);
        } else if (grp == 'partyroom') {
          partyroom_id = false;
        } else if (grp == 'partytheme') {
          food_enabled = true;
          current_price -= theme_surcharge;
          theme_surcharge = 0;

          // add back meal price if theme gets deselected and meal is not included
          if (!initial_meal_included && meal_included) {
            let mealPrice = calcMealPrice();
            current_price -= mealPrice;
            updatePrice();
          }
          meal_included = false;

          // unset care
          care_included = false;
          setCareIncl();

          // show/hide extras
          showHideExtras(0);
          extra_kid_price = extra_kid_price_default;
          checkExtraKids();
          resetExtras();
          deactivateThemefood();
        }
        $(this).removeClass('active');
        eval(grp + ' = false');
      } else {
        // remove active cake, add new cake
        if (grp == 'food_cake') {
          // remove old cake price from overall
          if (!cake_included && $('.js-partybooking-radio.active[data-grp=food_cake]').length > 0) current_price -= cake_price * 1;

          // add new price to overall
          cake_price = Number($(this).attr('data-price'));
          if (!cake_included) current_price += cake_price * 1;
        } else if (grp == 'partytime') {
          resetAllData();

          // if($('.js-partybooking-radio.active[data-grp=partytime]').length > 0){
          //     var old_party_price = Number($('.js-partybooking-radio.active[data-grp=partytime]').attr('data-price'));
          //     current_price -= old_party_price;
          // }

          // check if slot is happy hour
          // let old_happy_hour = happy_hour;
          happy_hour = $(this).attr('data-happyhour') == '1' ? true : false;
          // hide everything that shouldn't be shown for happy hour (currently cake)
          document.querySelectorAll('[data-hideforhappyhour="1"]').forEach(function (e) {
            if (happy_hour) e.classList.add('hidden');else e.classList.remove('hidden');

            // remove price if cake was active
            if (happy_hour && e.classList.contains('active')) {
              if (!cake_included) {
                current_price -= Number($(e).attr('data-price'));
              }
              e.classList.remove('active');
            }

            // show/hide complete cake section if no cakes visible
            if ($('.js-cake .js-partybooking-radio.hidden').length < $('.js-cake .js-partybooking-radio').length) {
              $('.js-cake').show(0);
            } else {
              $('.js-cake').hide(0);
            }
          });

          // set slot price
          current_price += Number($(this).attr('data-price'));

          // only change theme surcharge if the happy hour status changed
          // let current_meal_price = calcMealPrice();
          // let current_theme = ($('.js-partybooking-radio.active[data-grp=partytheme]').length > 0) ? $('.js-partybooking-radio.active[data-grp=partytheme]') : false;

          // if(old_happy_hour && !happy_hour){
          //     current_price += theme_surcharge;
          //     if(!initial_meal_included && current_theme !== false && meal_included) current_price -= current_meal_price;

          // } else if(!old_happy_hour && happy_hour){
          //     if(typeof old_party_price !== 'undefined') current_price -= theme_surcharge;
          //     if(!initial_meal_included){
          //         if(meal_included){
          //             current_price += current_meal_price;
          //         }
          //     }

          // } else if(typeof old_party_price !== 'undefined' && !old_happy_hour && !happy_hour){
          // } else if(old_happy_hour && happy_hour){

          // } else {
          //     current_price += theme_surcharge;
          //     if(!initial_meal_included && current_theme !== false && meal_included) current_price -= current_meal_price;
          // }

          // calculate extra kids price
          extra_kid_price = happy_hour ? extra_kid_price_happyhour : extra_kid_price_default;
          // if($('.js-partybooking-radio.active[data-grp=partytheme]').length > 0 && typeof $('.js-partybooking-radio.active[data-grp=partytheme]').data('extrakidcosts') !== 'undefined' && !happy_hour) extra_kid_price = Number($('.js-partybooking-radio.active[data-grp=partytheme]').data('extrakidcosts'));
          // checkExtraKids();

          // check meal included
          // if(current_theme !== false && typeof current_theme.data('mealincluded') !== 'undefined' && !happy_hour){
          //     if(Number(current_theme.data('mealincluded')) === 1){
          //         meal_included = true;
          //         showMealPrice(false);
          //     } else {
          //         meal_included = false;
          //         showMealPrice(true);
          //     }
          // } else if(happy_hour){
          if (happy_hour) {
            if (!exclude_happy_hour_food) {
              showMealPrice(false);
              meal_included = true;
            }
            showHideExtras(-1);
            deactivateThemefood();
          } else if (!initial_meal_included) {
            showMealPrice(true);
          }
          hideRooms($(this).attr('data-rooms'));

          // check if room can stay the same
          // if(partyroom_id !== false){
          //     if($(this).attr('data-rooms').indexOf(',' + partyroom_id + ',') >= 0){
          //         // room is still fine, do nothing
          //     } else {
          //         // deactivate room as not available in this slot
          //         deactivateRoom();
          //     }
          // }

          setCareNa();
          // resetExtras();
        } else if (grp == 'partyroom') {
          partyroom_id = Number($(this).attr('data-id'));
        } else if (grp == 'partytheme') {
          deactivateThemefood();

          // check if a theme is selected that should disable the whole food step
          food_enabled = $(this).attr('data-mealdisabled') && $(this).attr('data-mealdisabled').trim().length > 0 ? false : true;

          // check if in theme split, deactivate default themes button if split theme gets selected
          if ($(this).parent().find('.js-partytheme-step').length > 0) {
            $partytheme_step.removeClass('active');
          }

          // add back meal price if theme gets deselected and meal is not included
          let old_meal_included = meal_included;
          meal_included = $(this).attr('data-mealincluded') === '1' ? true : false;
          let themefood = $(this).attr('data-themefood') && $(this).attr('data-themefood').trim().length > 0 ? true : false;
          if (!initial_meal_included) {
            if (!old_meal_included && meal_included) {
              let mealPrice = calcMealPrice();
              current_price -= mealPrice;
            } else if (!old_meal_included && !food_enabled) {
              let mealPrice = calcMealPrice();
              current_price -= mealPrice;
              resetFood();
            } else if ((old_meal_included && !meal_included || !old_meal_included && !meal_included && themefood) && food_enabled) {
              if (themefood) activateThemefood($(this));
              let mealPrice = calcMealPrice();
              current_price += mealPrice;
            }
            updatePrice();
          }
          if (meal_included) {
            $('.js-food-meal-wrapper').addClass('meal-included');
          } else {
            $('.js-food-meal-wrapper').removeClass('meal-included');
          }

          // check theme if care is included in theme
          care_included = $(this).attr('data-careincluded') === '1' ? true : false;
          setCareIncl();

          // show/hide correct extras
          showHideExtras($(this).attr('data-id'));
          setThemeSurcharge(Number($(this).data('surcharge')));
          extra_kid_price = typeof $(this).data('extrakidcosts') !== 'undefined' ? Number($(this).data('extrakidcosts')) : extra_kid_price_default;
          checkExtraKids();
          resetExtras();
        }
        if (grp == 'partytheme') {
          $(this).closest('.partybooking__step').find('.js-partybooking-radio').removeClass('active');
        } else {
          $(this).siblings('.js-partybooking-radio').removeClass('active');
        }
        $(this).addClass('active');
        eval(grp + ' = "' + $(this).data('value') + '"');
      }
      updatePrice();
      checkstep(grp);
    });

    // counter
    $('.js-partybooking-counter').on('click', function () {
      var dir = Number($(this).data('dir'));
      var counter = $(this).parent().find('.partybooking__counter');
      var val = Number(counter.attr('data-val'));
      var wrap = $(this).parents('.js-counter-select');
      var grp = wrap.attr('data-grp');
      var price = Number(wrap.attr('data-price'));
      var goon = true;
      // prevent default if meal count is already as high as kids count
      if (grp == 'food_meal' && Number(dir) == 1) {
        var meal_count = 0;
        for (let key in food_meal) {
          meal_count += food_meal[key];
        }
        if (meal_count >= kids_count) goon = false;
      }
      // prevent adding more than 3 extra care hours
      if (wrap.hasClass('js-extra-care')) {
        if (val >= 3 && dir > 0) goon = false;
      }
      if (goon) {
        val = val + dir;
        if (val < 0) {
          val = 0;
        } else {
          if (grp == 'food_snacks' || grp == 'partyextras' || grp == 'food_meal' && initial_meal_included === false && meal_included === false) {
            current_price += price * dir;
          }
        }
        updatePrice();
        counter.attr('data-val', val);
        counter.text(val);
        var temp = eval(grp);
        temp[wrap.attr('data-title')] = val;
        if (val == 0) delete temp[wrap.attr('data-title')];
        if (grp.indexOf('food_') >= 0) checkstep('food');
      }
    });
    // counter for single buttons
    $('.js-partybooking-counter-single').on('click', function () {
      let $this = $(this);
      let wrap = $(this).parents('.js-counter-select');
      let grp = wrap.attr('data-grp');
      let price = Number(wrap.attr('data-price'));
      let val = 0;
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.text($this.attr('data-labeladd'));
        $this.attr('data-val', 0);
        current_price -= price;
      } else {
        val = 1;
        $this.addClass('active');
        $this.text($this.attr('data-labelremove'));
        $this.attr('data-val', 1);
        current_price += price;
      }
      updatePrice();
      let temp = eval(grp);
      temp[wrap.attr('data-title')] = val;
      if (val == 0) delete temp[wrap.attr('data-title')];
    });

    // checkbox
    $('.js-checkbox').on('click', function () {
      $(this).toggleClass('active');
      checkstep('agb');
    });

    // variable bindings
    $('.js-kids-count').on('change', function () {
      // calculate cake price if cake already selected
      if (cake_price > 0) current_price -= cake_price * 1;
      kids_count = $(this).val();
      checkstep('partytime');
      checkExtraKids();

      // calculate cake price if cake already selected
      if (cake_price > 0) current_price += cake_price * 1;
      if (cake_price > 0) {
        updatePrice();
      }
    });
    $('.js-kids-age').on('keyup', function () {
      kids_age = $(this).val();
      checkstep('partytime');
    });
    $('.js-partybooking-form').on('keyup', function () {
      checkstep('form');
    });
  };

  // check price for extra kids
  var checkExtraKids = function () {
    current_price -= temp_extra_kids_price;
    if (kids_count > default_kids_count) {
      var extra = kids_count - default_kids_count;
      temp_extra_kids_price = extra_kid_price * extra;
    } else {
      temp_extra_kids_price = 0;
    }
    current_price += temp_extra_kids_price;
    updatePrice();
  };
  var setThemeSurcharge = function (new_val) {
    current_price -= theme_surcharge;
    theme_surcharge = new_val;
    current_price += theme_surcharge;
  };

  // check if everything needed is filled out for this step to activate the next step button
  var checkstep = function (s) {
    var retval = false;
    switch (s) {
      case 'partytime':
        if (kids_age !== false && kids_age != '' && partytime !== false) retval = true;
        break;
      case 'partytheme':
        if ($('.js-partytheme').find('.js-partybooking-radio.active').length > 0) partytheme = $('.js-partytheme').find('.js-partybooking-radio.active').attr('data-value');

        // check cake price after checking if theme includes cake
        if (cake_price > 0 && !cake_included) current_price -= cake_price * 1;
        cake_included = $('.js-partytheme').find('.js-partybooking-radio.active').attr('data-cakeincluded') === '1' ? true : false;
        if (cake_price > 0 && !cake_included) current_price += cake_price * 1;
        if (cake_included) {
          $('.js-cake .price').hide(0);
        } else {
          $('.js-cake .price').show(0);
        }
        care_included = $('.js-partytheme').find('.js-partybooking-radio.active').attr('data-careincluded') === '1' ? true : false;
        if (partytheme !== false) retval = true;
        updatePrice();
        break;
      case 'partyroom':
        if (partyroom !== false) retval = true;
        break;
      case 'food_cake':
      case 'food':
        //if(!jQuery.isEmptyObject(food_meal)) 
        var meal_count = 0;
        for (let key in food_meal) {
          meal_count += food_meal[key];
        }
        // if(meal_count == kids_count) retval = true;
        if (meal_count > 0 || meal_notavailable || selffood || themefood) retval = true;
        break;
      case 'extras':
        retval = true;
        break;
      case 'form':
        retval = checkForm();
        break;
      case 'agb':
        var retval = true;
        $('.js-partybooking-step-agb .js-checkbox.js-required').each(function () {
          if (!$(this).hasClass('active')) retval = false;
        });
        break;
      case 'overview':
        fillForm();
        retval = true;
        break;
    }
    nextStepStatus(retval);
  };

  // validate form step input
  var checkForm = function () {
    var retval = true;
    $('.js-partybooking-form input').each(function () {
      if ($(this).val().length < 1) retval = false;
      if ($(this).attr('name') == 'email' && !validateEmail($(this).val())) retval = false;
    });
    return retval;
  };

  // fill the form with all the data collected in the previous steps
  var fillForm = function () {
    $('.js-form-money-overview').empty();
    var extra_data = '';

    //party
    $('.js-form-datetime').html(partydate + ' ' + partytime);
    $('.js-form-kids-count').html(kids_count);
    $('.js-form-kids-age').html(kids_age);
    if (partytheme == 'Happy Hour') {
      $('.js-form-theme').html(partytheme);
    } else {
      $('.js-form-theme').html(partytheme + ' - ' + $('.js-theme-desc[data-title="' + partytheme + '"]').first().text());
    }
    $('.js-form-room').html(partyroom);
    var no_cake = typeof $('.js-food-cake').parent().find('.js-partybooking-radio[data-value="' + food_cake + '"]').first().attr('data-self') !== 'undefined';
    var kids_cake_text = no_cake ? translations.kids_without_cake : translations.kids_with_cake;
    var party_cake_price = temp_extra_kids_price + Number($partytime.find('.js-partybooking-radio.active').attr('data-price'));
    if (no_cake || cake_included) {} else {
      party_cake_price = party_cake_price + Number(cake_price) * 1;
    }
    party_cake_price += theme_surcharge;
    extra_data += '<div class="partybooking__overview__item__cell"><div class="left">' + kids_count + ' ' + kids_cake_text + '</div><div class="right">' + party_cake_price + ' ' + translations.currency + '</div></div>';

    // food
    $('.js-form-food').empty();
    var hide_food = true;
    if (food_cake !== false) {
      $('.js-form-food').append('<div class="partybooking__overview__item__cell js-changestep" data-goto="food"><span class="icon icon--pencil"></span><div class="left">' + $('.js-food-cake').text() + '</div><div class="right">' + food_cake + '</div></div>');
      hide_food = false;
    }
    if (!jQuery.isEmptyObject(food_meal)) {
      var first = true;
      var v = '';
      for (let key in food_meal) {
        if (first) {
          first = false;
        } else {
          v += '<br />';
        }
        v += food_meal[key] + ' ' + key;
      }
      $('.js-form-food').append('<div class="partybooking__overview__item__cell js-changestep" data-goto="food"><span class="icon icon--pencil"></span><div class="left">' + $('.js-food-meal').text() + '</div><div class="right">' + v + '</div></div>');
      let final_meal_price = calcMealPrice() + ' ' + translations.currency;
      if (initial_meal_included || meal_included) final_meal_price = translations.incl;
      extra_data += '<div class="partybooking__overview__item__cell"><div class="left">' + $('.js-food-meal').text() + '</div><div class="right">' + final_meal_price + '</div></div>';
      hide_food = false;
    } else if (themefood) {
      hide_food = false;
      $('.js-form-food').append('<div class="partybooking__overview__item__cell js-changestep" data-goto="food"><span class="icon icon--pencil"></span><div class="left">' + $('.js-food-meal').text() + '</div><div class="right">' + $('.js-themefood').text() + '</div></div>');
    } else if (selffood) {
      hide_food = false;
      $('.js-form-food').append('<div class="partybooking__overview__item__cell js-changestep" data-goto="food"><span class="icon icon--pencil"></span><div class="left">' + $('.js-food-meal').text() + '</div><div class="right">' + $('.js-selffood').text() + '</div></div>');
    }
    if (!jQuery.isEmptyObject(food_snacks)) {
      var first = true;
      var v = '';
      for (let key in food_snacks) {
        if (first) {
          first = false;
        } else {
          v += '<br />';
        }
        v += food_snacks[key] + ' ' + key;
        var price = Number($('.js-food-snacks').parent().find('.js-counter-select[data-title="' + key + '"]').first().attr('data-price')) * food_snacks[key];
        extra_data += '<div class="partybooking__overview__item__cell"><div class="left">' + food_snacks[key] + ' ' + key + '</div><div class="right">' + price.toFixed(2).replace('.', ',') + ' ' + translations.currency + '</div></div>';
      }
      $('.js-form-food').append('<div class="partybooking__overview__item__cell js-changestep" data-goto="food"><span class="icon icon--pencil"></span><div class="left">' + $('.js-food-snacks').text() + '</div><div class="right">' + v + '</div></div>');
      hide_food = false;
    }
    if (hide_food) {
      $('.js-overview-food').hide(0);
    } else {
      $('.js-overview-food').show(0);
    }

    // data
    $('.js-form-kid-lastname').html($('.js-partybooking-form input[name=kid_lastname]').val());
    $('.js-form-kid-firstname').html($('.js-partybooking-form input[name=kid_firstname]').val());
    var birthdate_help = $('.js-partybooking-form input[name=kid_birthdate]').val().split('-');
    var birthdate = birthdate_help[2] + '.' + birthdate_help[1] + '.' + birthdate_help[0];
    $('.js-form-birthdate').html(birthdate);
    $('.js-form-adult-lastname').html($('.js-partybooking-form input[name=adult_lastname]').val());
    $('.js-form-adult-firstname').html($('.js-partybooking-form input[name=adult_firstname]').val());
    $('.js-form-address').html($('.js-partybooking-form input[name=street]').val() + '<br />' + $('.js-partybooking-form input[name=zip]').val() + ' ' + $('.js-partybooking-form input[name=city]').val());
    $('.js-form-phone').html($('.js-partybooking-form input[name=phone]').val());
    $('.js-form-email').html($('.js-partybooking-form input[name=email]').val());
    var brstring = $('.js-partybooking-form textarea[name=extrainfo]').val().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
    $('.js-form-extrainfo').html(brstring);

    // fetch extras
    if ($('.js-partybooking-step-extras').length > 0) {
      for (let key in partyextras) {
        var price = Number($('.js-partybooking-step-extras .js-counter-select[data-title="' + key + '"]').first().attr('data-price')) * partyextras[key];
        extra_data += '<div class="partybooking__overview__item__cell"><div class="left">' + partyextras[key] + ' ' + key + '</div><div class="right">' + price.toFixed(2).replace('.', ',') + ' ' + translations.currency + '</div></div>';
      }
    }

    // add extra data to overview
    $('.js-form-money-overview').append(extra_data);

    // money
    $('.js-full-price').text(current_price.toFixed(2).replace('.', ','));
  };

  // set status for next step button in bar
  var nextStepStatus = function (todo) {
    if (todo === true) {
      $('.js-partybooking-nextstep').removeClass('disabled');
    } else {
      $('.js-partybooking-nextstep').addClass('disabled');
    }
  };

  // close step selction dropdown on outside click
  var clickOutside = function (e) {
    var $target = $(e.target);
    if ($step_selection.hasClass('active') && !$target.hasClass('js-partybooking-stepselector') && !$target.parents().hasClass('js-partybooking-stepselector')) {
      $step_selection.removeClass('active');
      $partybooking.removeClass('activestepselection');
      $step_selector.removeClass('active');
    }
  };

  // step selection dropdown
  var selectStep = function (e) {
    e.preventDefault();
    $step_selection.toggleClass('active');
    $partybooking.toggleClass('activestepselection');
    $step_selector.toggleClass('active');
  };

  // go to next step
  var gotoStep = function (e) {
    if (typeof e !== 'undefined') e.preventDefault();
    if (meal_included || initial_meal_included) {
      $('.js-selffood').addClass('hidden');
    } else {
      $('.js-selffood').removeClass('hidden');
    }

    // jump to top and show navi on next step
    window.scrollTo(0, 0);
    $('html').removeClass('page--nav-scroll');
    nextStepStatus();
    current_step += 1;
    showStep(current_step);
  };

  // jump to step
  var showStep = function (step, back) {
    // set current step, initially hide all steps
    current_step = Number(step);

    // if happy hour, skip theme selection
    if (typeof back !== 'undefined' && back === true && happy_hour && current_step == 2) {
      showStep(1);
    } else if (food_enabled === false && current_step == 4 && back === true) {
      showStep(3);
    } else if (food_enabled === false && current_step == 4 && back !== true) {
      showStep(5);
    } else if (happy_hour && current_step == 2) {
      partytheme = 'Happy Hour';
      gotoStep();
    } else {
      $all_steps.hide(0);
      if (current_step >= $all_steps.length - 1) {
        $('.js-partybooking-done').css({
          display: 'inline-block'
        });
        $('.js-partybooking-nextstep').hide(0);
      } else {
        $('.js-partybooking-nextstep').css({
          display: 'inline-block'
        });
        $('.js-partybooking-done').hide(0);
      }

      // in case we are jumping to theme selection and split theme is active, always set initial state and show first substep
      if (current_step === 2 && $('.js-partytheme-step1').length > 0) {
        $('.js-partytheme-step1').removeClass('hidden');
        $('.js-partytheme-step2').addClass('hidden');
        if ($('.js-partytheme-step2 .js-partybooking-radio.active').length < 1) $partytheme_step.removeClass('active');
      }

      // jump to top and show navi on next step
      window.scrollTo(0, 0);
      $('html').removeClass('page--nav-scroll');
      if (current_step > 0) {
        $('.js-partybooking-bar').removeClass('hidden');

        // set states for steps in selector dropdown
        var step_count = $('.js-partybooking-stepselection .js-step').length;
        for (var i = 1; i <= step_count; i++) {
          if (i < current_step) $('.js-partybooking-stepselection .js-step[data-step=' + i + ']').removeClass('active').removeClass('disabled');
          if (i == current_step) {
            $('.js-partybooking-stepselection .js-step[data-step=' + i + ']').addClass('active').removeClass('disabled');
            $('.js-partybooking-stepselector .text').html($('.js-partybooking-stepselection .js-step[data-step=' + i + ']').html());
          }
          if (i > current_step) $('.js-partybooking-stepselection .js-step[data-step=' + i + ']').removeClass('active').addClass('disabled');
        }

        // deactivate theme if happy hour selected
        if (happy_hour) $('.js-partybooking-stepselection .js-step[data-step=2]').removeClass('active').addClass('disabled');

        // jump back to start screen, hide bar and reset bar to step 1
      } else {
        $('.js-partybooking-bar').addClass('hidden');
        $('.js-partybooking-stepselector .text').html($('.js-partybooking-stepselection .js-step[data-step=1] .inner').html());
      }

      // show current step and trigger the check to see if the next button should be active
      setTimeout(function () {
        $('.js-partybooking-step-' + current_step).show(0);
        checkstep($('.js-partybooking-step-' + current_step).attr('data-check'));
      }, 10);
    }
  };

  // validate email address
  var validateEmail = function (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };
  var updatePrice = function () {
    $('.js-price').text(current_price.toFixed(2).replace('.', ','));
  };
  var calcMealPrice = function () {
    var retval = 0;
    $('.js-partybooking-food-elems .partybooking__counter').each(function () {
      let count = Number($(this).attr('data-val'));
      if (count > 0) {
        let price = Number($(this).parents('.js-counter-select').attr('data-price'));
        retval += price * count;
      }
    });
    return retval;
  };
  var deactivateRoom = function () {
    partyroom_id = false;
    partyroom = false;
    $('.js-partyroom .js-partybooking-radio.active').removeClass('active');
  };
  var hideRooms = function (rooms) {
    if (rooms === false) {
      $('.js-partyroom .js-partybooking-radio').removeClass('hidden');
    } else {
      $('.js-partyroom .js-partybooking-radio').addClass('hidden');
      var r = rooms.split(',');
      r.forEach(function (room_id) {
        if (room_id != "") {
          $('.js-partyroom .js-partybooking-radio[data-id="' + room_id + '"]').removeClass('hidden');
        }
      });
    }
  };
  var submitBooking = function () {
    var birthdate_help = $('.js-partybooking-form input[name=kid_birthdate]').val().split('-');
    var birthdate = birthdate_help[2] + '.' + birthdate_help[1] + '.' + birthdate_help[0];
    $.ajax({
      url: blog_path + 'api/partybooking_book',
      type: 'post',
      data: {
        pageid: pageid,
        roomid: partyroom_id,
        childFirstName: $('.js-partybooking-form input[name=kid_firstname]').val(),
        childLastName: $('.js-partybooking-form input[name=kid_lastname]').val(),
        childSex: 0,
        // check
        birthdate: birthdate,
        kidsCount: kids_count,
        kidsAge: kids_age,
        theme: happy_hour ? 'Happy Hour' : $('.js-partytheme').find('.js-partybooking-radio.active').attr('data-value'),
        start: $partytime.find('.js-partybooking-radio.active').attr('data-start'),
        end: $partytime.find('.js-partybooking-radio.active').attr('data-end'),
        cake: $('.js-cake').find('.js-partybooking-radio.active').attr('data-value'),
        adultFirstname: $('.js-partybooking-form input[name=adult_firstname]').val(),
        adultLastName: $('.js-partybooking-form input[name=adult_lastname]').val(),
        adultSex: 1,
        phone: $('.js-partybooking-form input[name=phone]').val(),
        email: $('.js-partybooking-form input[name=email]').val(),
        street: $('.js-partybooking-form input[name=street]').val(),
        zip: $('.js-partybooking-form input[name=zip]').val(),
        city: $('.js-partybooking-form input[name=city]').val(),
        otherData: $('.js-partybooking-form textarea[name=extrainfo]').val().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2'),
        meal: food_meal,
        snacks: food_snacks,
        selffood: selffood,
        themefood: themefood ? $('.js-themefood').text() : 'false',
        extras: partyextras,
        food_enabled: food_enabled
      },
      dataType: 'json'
    }).done(function (data) {
      if (data.meta.success === true) {
        window.location.href = finalurl;
      } else {
        if (data.meta.error_message == 'timeslot_gone') {
          alert(translations.timeslot_gone);
        }
      }
    });
  };
  var getFullExtraPrices = function () {
    let fullprice = 0;
    for (let key in partyextras) {
      fullprice += Number($('.js-partybooking-step-extras .js-counter-select[data-title="' + key + '"]').first().attr('data-price')) * partyextras[key];
    }
    return fullprice;
  };
  var resetExtras = function () {
    let extraprice = getFullExtraPrices();
    current_price -= extraprice;
    partyextras = new Object();
    $('.js-partybooking-step-extras .js-counter-select .partybooking__counter__wrapper .partybooking__counter').text('0');
    $('.js-partybooking-step-extras .js-counter-select .partybooking__counter__wrapper .partybooking__counter').attr('data-val', '0');
    $('.js-partybooking-counter-single').each(function () {
      $(this).removeClass('active');
      $(this).text($(this).attr('data-labeladd'));
      $(this).attr('data-val', 0);
    });
  };
  var resetFood = function () {
    $('.js-cake .js-partybooking-radio').removeClass('active');
    $('.js-selffood').removeClass('active');
    $('.js-selffood').removeClass('hidden');
    $('.js-partybooking-food-elems').removeClass('partybooking__foodbar__counter--blocked');
    $('.js-partybooking-food-elems .partybooking__counter').text('0');
    $('.js-partybooking-food-elems .partybooking__counter').attr('data-val', '0');
    $('.js-food-snacks-wrapper .partybooking__counter').text('0');
    $('.js-food-snacks-wrapper .partybooking__counter').attr('data-val', '0');
    food_cake = false;
    food_meal = new Object();
    food_snacks = new Object();
    selffood = false;
    meal_price = 0;
  };
  var showHideExtras = function (extraid) {
    const $extras = $('[data-grp="partyextras"]');
    $extras.removeClass('hidden');

    // send extraid -1 if happyhour
    if (extraid < 0) {
      $extras.each(function () {
        const themes = JSON.parse($(this).attr('data-themes'));
        if (themes.length > 0) $(this).addClass('hidden');
      });
    } else if (extraid !== 0) {
      $extras.each(function () {
        const themes = JSON.parse($(this).attr('data-themes'));
        if (themes.length > 0 && themes.indexOf(Number(extraid)) < 0) $(this).addClass('hidden');
      });
    }
    let visibleExtras = 0;
    $extras.each(function () {
      if ($(this).css('display') !== 'none') visibleExtras++;
    });
    if (visibleExtras < 1) {
      $('.js-no-extras').show(0);
    } else {
      $('.js-no-extras').hide(0);
    }
  };
  var setCareIncl = function () {
    if (care_included) {
      $('.js-extra-care').addClass('care_included');
    } else {
      $('.js-extra-care').removeClass('care_included');
    }
  };
  var setCareNa = function () {
    if (happy_hour) {
      $('.js-extra-care').addClass('happyhour');
    } else {
      $('.js-extra-care').removeClass('happyhour');
    }
  };
  var showMealPrice = function (to) {
    if (!to) {
      $('.js-food-meal-wrapper').addClass('meal-included');
    } else {
      $('.js-food-meal-wrapper').removeClass('meal-included');
    }
  };
  var deactivateThemefood = function () {
    themefood = false;
    $('.js-selffood').removeClass('hidden--override');
    $('.js-themefood').remove();
    $('.js-partybooking-food-elems').removeClass('partybooking__foodbar__counter--blocked');
  };
  var activateThemefood = function (elem) {
    themefood = true;
    $('.js-selffood').addClass('hidden--override');
    $('<div class="partybooking__foodbar__addon partybooking__foodbar__addon--wide js-themefood">' + elem.attr('data-themefood') + '</div>').insertAfter('.js-food-meal-wrapper');
    $('.js-partybooking-food-elems').addClass('partybooking__foodbar__counter--blocked');

    // remove price from full price when selffood gets activated
    let mealPrice = calcMealPrice();
    current_price -= mealPrice;
    updatePrice();
    food_meal = new Object();
    $('.js-partybooking-food-elems .partybooking__counter').text('0');
    $('.js-partybooking-food-elems .partybooking__counter').attr('data-val', '0');
  };
  var resetAllData = function () {
    // adjust html
    $('.js-partytheme .js-partybooking-radio').removeClass('active'), $('.js-partyroom .js-partybooking-radio').removeClass('active');
    $('.js-partyroom .js-partybooking-radio').removeClass('hidden');
    $('.js-kids-age').val('');
    $('.js-extra-care').removeClass('care_included');
    $('.js-extra-care').removeClass('happyhour');
    showMealPrice(true);
    resetExtras();

    // adjust food
    $('.js-cake .js-partybooking-radio').removeClass('active');
    $('.js-selffood').removeClass('active');
    $('.js-selffood').removeClass('hidden');
    $('.js-partybooking-food-elems').removeClass('partybooking__foodbar__counter--blocked');
    $('.js-partybooking-food-elems .partybooking__counter').text('0');
    $('.js-partybooking-food-elems .partybooking__counter').attr('data-val', '0');
    $('.js-food-snacks-wrapper .partybooking__counter').text('0');
    $('.js-food-snacks-wrapper .partybooking__counter').attr('data-val', '0');
    $('.js-kids-count').val("1").change();
    $('.js-kids-count option[value="1"]').attr("selected", "selected");
    $('.js-kids-count').closest('.selectric-hide-select').next('.selectric').find('.label').text('1');
    $('.js-kids-count').closest('.selectric-hide-select').next('.selectric').next('.selectric-items').find('li').removeClass('selected').removeClass('highlighted');
    $('.js-kids-count').closest('.selectric-hide-select').next('.selectric').next('.selectric-items').find('li:first-child').addClass('selected').addClass('highlighted');
    current_step = 1;
    current_price = 0;
    cake_price = 0;

    // booking varialbes
    partytime = false;
    kids_count = 1;
    kids_age = false;
    partytheme = false;
    partyroom = false;
    partyroom_id = false;
    food_cake = false;
    food_meal = new Object();
    food_snacks = new Object();
    selffood = false;
    partyextras = new Object();
    care_included = false;
    extra_kid_price_happyhour = Number($el.attr('data-price-extrakids-happyhour'));
    extra_kid_price_default = Number($el.attr('data-price-extrakids'));
    extra_kid_price = Number($el.attr('data-price-extrakids'));
    happy_hour = false;
    temp_extra_kids_price = 0;
    theme_surcharge = 0;
    cake_included = false;
    meal_included = false;
    meal_price = 0;
    cal_xhr = false;
  };
  init();
  return api;
};
app.ext['quotes-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-quotes-swiper-container');
  var $pagination = $el.find('.js-quotes-swiper-pagination');
  var $prev = $el.find('.js-quotes-swiper-prev');
  var $next = $el.find('.js-quotes-swiper-next');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      slidesPerView: 1,
      // spaceBetween: 100,
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext['reviews-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-reviews-swiper-container');
  var $pagination = $el.find('.js-reviews-swiper-pagination');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      breakpoints: {
        440: {
          slidesPerView: 1
        },
        // when window width is >= 640px
        890: {
          slidesPerView: 3
        }
      },
      spaceBetween: 100,
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext["scroll"] = function ($el) {
  var api = {};
  var init = function () {
    addListeners();
  };
  var addListeners = function () {
    $el.on("click", scrollTo);
  };
  var scrollTo = function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html, body").animate({
        scrollTop: $(hash).offset().top
      }, 800, function () {
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  };
  init();
  return api;
};
app.ext['share'] = function ($el) {
  var api = {};
  var $facebook = $('.js-share-facebook');
  var $twitter = $('.js-share-twitter');
  var $pinterest = $('.js-share-pinterest');
  var init = function () {
    addListeners();
  };
  var addListeners = function () {
    $facebook.on("click", shareOnFacebook);
    $twitter.on("click", shareOnTwitter);
    $pinterest.on("click", shareOnPinterest);
  };
  var shareOnFacebook = function (e) {
    e.preventDefault();
    var url = window.location.href;
    var resultUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
    console.log(resultUrl);
    window.open(resultUrl, '_blank');
  };
  var shareOnTwitter = function (e) {
    e.preventDefault();
    var url = window.location.href;
    var resultUrl = 'http://twitter.com/share?url=' + url;
    window.open(resultUrl, '_blank');
  };
  var shareOnPinterest = function (e) {
    e.preventDefault();
    var url = window.location.href;
    var resultUrl = 'https://pinterest.com/pin/create/button/?url=' + url + '&media=&description=';
    console.log(resultUrl);
    window.open(resultUrl, '_blank');
  };
  init();
  return api;
};
app.ext['skip-links'] = function ($el) {
  var api = {};
  var $buttonContent = $el.find('.js-skip-link--content');
  var $buttonFooter = $el.find('.js-skip-link--footer');
  var init = function () {
    addEventListeners();
  };
  var focusNextFocussableElement = function ($container) {
    if (!$container.length) return;
    const $focusable = $container.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible:not(:disabled)');
    const currentIndex = $focusable.index(document.activeElement);
    const nextIndex = (currentIndex + 1) % $focusable.length;
    $focusable.eq(nextIndex).trigger('focus');
  };
  var addEventListeners = function () {
    $buttonContent.on('click', () => {
      focusNextFocussableElement($('.content'));
    });
    $buttonFooter.on('click', () => {
      focusNextFocussableElement($('footer'));
    });
  };
  init();
  return api;
};
var spoilerCounter = 0;
app.ext['spoiler'] = function ($el) {
  var api = {};
  var $button = $('.js-spoiler-button');
  var $answer = $('.js-spoiler-answer');
  var init = function () {
    spoilerCounter++;
    $el.find($button).attr('aria-expanded', false);
    $el.find($button).attr('aria-controls', 'spoiler-answer-' + spoilerCounter);
    $el.find($answer).attr('id', 'spoiler-answer-' + spoilerCounter);
    $el.find($button).on('click', function () {
      var $this = $(this);
      var $parent = $this.closest('.js-spoiler');
      $parent.toggleClass('is-active');
      var isOpen = $parent.hasClass('is-active');
      $parent.find($answer).slideToggle(200);
      $this.attr('aria-expanded', isOpen);
    });
  };
  init();
  return api;
};
app.ext['team-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-team-swiper-container');
  var $pagination = $el.find('.js-team-swiper-pagination');
  var $prev = $el.find('.js-team-swiper-prev');
  var $next = $el.find('.js-team-swiper-next');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      breakpoints: {
        // when window width is >= 320px
        320: {
          initialSlide: 0
        },
        481: {
          initialSlide: 2
        }
      },
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext['teasers-row-swiper'] = function ($el) {
  var api = {};
  var $swiper = $el.find('.js-teasers-row-swiper-container');
  var $pagination = $el.find('.js-teasers-row-swiper-pagination');
  var $prev = $el.find('.js-teasers-row-swiper-prev');
  var $next = $el.find('.js-teasers-row-swiper-next');
  var init = function () {
    init_swiper();
  };
  var init_swiper = function () {
    var mySwiper = new Swiper($swiper, {
      a11y: swiperA11yOptions,
      breakpoints: {
        // when window width is >= 320px
        320: {
          initialSlide: 0
        },
        481: {
          initialSlide: 1
        }
      },
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      pagination: {
        el: $pagination,
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev
      },
      // set inert to non visible slides
      on: {
        init: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        },
        slideChangeTransitionEnd: function () {
          $swiper.find('.swiper-slide').attr('inert', true);
          $swiper.find('.swiper-slide-active').removeAttr('inert');
        }
      }
    });
  };
  init();
  return api;
};
app.ext['video-container'] = function ($el) {
  var api = {};
  var $pauseButton = $el.find('.js-pause-video');
  var init = function () {
    $pauseButton.on('click', function () {
      var $this = $(this);
      var $parent = $this.parent();
      var $html5Video = $parent.find('video');
      if (!$html5Video.length) return;
      if ($html5Video[0].paused) {
        $html5Video[0].play();
        var labelPause = translate('pauseVideo');
        if (labelPause) $this.text(labelPause);
      } else {
        $html5Video[0].pause();
        var labelPlay = translate('playVideo');
        if (labelPlay) $this.text(labelPlay);
      }
    });
  };
  init();
  return api;
};
app.ext['youtube-bg'] = function ($el) {
  var api = {};
  var $pauseButton = $('.js-pause-video');
  var init = function () {
    $el.youtube_background();
    $pauseButton.on('click', function () {
      var $this = $(this);
      var $parent = $this.parent();
      var $video = $parent.find('.youtube-background');
      var player = $video.data('yt-player');
      if ($this.hasClass('paused')) {
        $this.removeClass('paused');
        $this.find('i').addClass('fa-pause-circle').removeClass('fa-play-circle');
        if (player) {
          player.playVideo();
          var labelPause = translate('pauseVideo');
          if (labelPause) $this.text(labelPause);
        }
      } else {
        $this.addClass('paused');
        $this.find('i').removeClass('fa-pause-circle').addClass('fa-play-circle');
        if (player) {
          player.pauseVideo();
          var labelPlay = translate('playVideo');
          if (labelPlay) $this.text(labelPlay);
        }
      }
    });
  };

  /* jquery.youtube-background v1.0.4 | Nikola Stamatovic <@stamat> | MIT */
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/player_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  (function ($) {
    $.fn.youtube_background = function (params) {
      var YOUTUBE = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
      var $this = $(this);
      var defaults = {
        pause: false,
        //deprecated
        'play-button': false,
        'mute-button': false,
        autoplay: true,
        muted: true,
        loop: true,
        mobile: false,
        'load-background': true
      };
      if (!params) {
        params = defaults;
      } else {
        for (let k in defaults) {
          //load in defaults
          if (!params.hasOwnProperty(k)) {
            params[k] = defaults[k];
          }
        }
      }

      //pause deprecated
      if (params.pause) {
        params['play-button'] = params.pause;
      }
      function onVideoPlayerReady(event) {
        if (params.autoplay) {
          event.target.playVideo();
        }
        $(event.target.a).css({
          top: '50%',
          left: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
          position: 'absolute'
        });
        var $root = $(event.target.a).parent();
        function onResize() {
          var h = $root.outerHeight() + 100; // since showinfo is deprecated and ignored after September 25, 2018. we add +100 to hide it in the overflow
          var w = $root.outerWidth() + 100;
          var res = 1.77777778;
          if (res > w / h) {
            $root.find('iframe').width(h * res).height(h);
          } else {
            $root.find('iframe').width(w).height(w / res);
          }
        }
        $(window).on('resize', onResize);
        onResize();
      }
      function onVideoStateChange(event) {
        //video loop
        if (event.data === 0 && params.loop) {
          event.target.playVideo();
        }
      }
      function build() {
        if (!window.hasOwnProperty('__ytbg_index')) {
          window.__ytbg_index = {};
        }

        //iterate elements
        for (let i = 0; i < $this.length; i++) {
          var $elem = $($this[i]);
          if ($elem.parent().hasClass('youtube-background')) {
            continue;
          }
          var ytid = $elem.data('youtube');
          if (!ytid) {
            continue;
          }
          var pts = ytid.match(YOUTUBE);
          if (pts && pts.length) {
            ytid = pts[1];
            YOUTUBE.lastIndex = 0; //regex needs a reset in for loops, I always forget this
          } else {
            continue;
          }
          for (let k in params) {
            var data = $elem.data('ytbg-' + k);
            if (data !== undefined && data !== null) {
              params[k] = data;
            }
          }

          //pause deprecated
          if (params.pause) {
            params['play-button'] = params.pause;
          }
          $elem.wrap('<div class="youtube-background" />');
          var $root = $elem.parent();

          //set css rules
          $root.css({
            height: '100%',
            width: '100%',
            'z-index': '0',
            position: 'absolute',
            overflow: 'hidden',
            top: 0,
            // added by @insad
            left: 0,
            bottom: 0,
            right: 0,
            'pointer-events': 'none' // avoid right mouse click popup menu
          });
          if (params['load-background']) {
            $root.css({
              'background-image': 'url(https://img.youtube.com/vi/' + ytid + '/maxresdefault.jpg)',
              'background-size': 'cover',
              'background-repeat': 'no-repeat',
              'background-position': 'center'
            });
          }
          $root.parent().css({
            position: 'relative'
          });

          //if mobile browser break
          var is_mobile = false;
          (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) is_mobile = true;
          })(navigator.userAgent || navigator.vendor || window.opera);
          if (is_mobile && !params.mobile) {
            continue;
          }
          if (params['play-button'] || params['mute-button']) {
            var $vbc = $('<div class="video-background-controls" />');
            $vbc.css({
              position: 'absolute',
              'z-index': 2,
              top: '10px',
              right: '10px'
            });
            $root.parent().append($vbc);
          }

          //add a play toggle button
          if (params['play-button']) {
            var $btn = $('<button class="play-toggle"><i class="fa fa-pause-circle"></i></button>');
            if (!params.autoplay) {
              $btn.addClass('paused');
              $this.find('i').removeClass('fa-pause-circle').addClass('fa-play-circle');
            }
            $btn.on('click', function () {
              var $this = $(this);
              var player = $this.parent().parent().find('.youtube-background').data('yt-player');
              if ($this.hasClass('paused')) {
                $this.removeClass('paused');
                $this.find('i').addClass('fa-pause-circle').removeClass('fa-play-circle');
                if (player) {
                  player.playVideo();
                }
              } else {
                $this.addClass('paused');
                $this.find('i').removeClass('fa-pause-circle').addClass('fa-play-circle');
                if (player) {
                  player.pauseVideo();
                }
              }
            });
            $root.parent().find('.video-background-controls').append($btn);
          }
          if (params['mute-button']) {
            var $btn = $('<button class="mute-toggle"><i class="fa fa-volume-up"></i></button>');
            if (params.muted) {
              $btn.addClass('muted');
              $btn.find('i').addClass('fa-volume-mute').removeClass('fa-volume-up');
            }
            $btn.on('click', function () {
              var $this = $(this);
              var player = $this.parent().parent().find('.youtube-background').data('yt-player');
              if (!$this.hasClass('muted')) {
                $this.addClass('muted');
                $this.find('i').addClass('fa-volume-mute').removeClass('fa-volume-up');
                if (player) {
                  player.mute();
                }
              } else {
                $this.removeClass('muted');
                $this.find('i').removeClass('fa-volume-mute').addClass('fa-volume-up');
                if (player) {
                  player.unMute();
                }
              }
            });
            $root.parent().find('.video-background-controls').append($btn);
          }

          //index the instance
          function getRandomIntInclusive(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
          }
          var uid = ytid + '-' + getRandomIntInclusive(0, 999);
          while (window.__ytbg_index.hasOwnProperty(uid)) {
            uid = ytid + '-' + getRandomIntInclusive(0, 999);
          }
          window.__ytbg_index[uid] = {
            elem: $elem[0],
            ytid: ytid
          };
        }
      }
      build();
      window.onYouTubeIframeAPIReady = function () {
        //instance index iterate
        for (let k in window.__ytbg_index) {
          var entry = window.__ytbg_index[k];
          var $root = $(entry.elem).parent();
          var ytp = new YT.Player(entry.elem, {
            height: '1080',
            width: '1920',
            videoId: entry.ytid,
            playerVars: {
              controls: 0,
              autoplay: params.autoplay ? 1 : 0,
              mute: params.muted ? 1 : 0,
              origin: window.location.origin,
              loop: params.loop ? 1 : 0,
              rel: 0,
              ecver: 2,
              showinfo: 0,
              modestbranding: 1
            },
            events: {
              onReady: onVideoPlayerReady,
              onStateChange: onVideoStateChange
            }
          });
          $root.data('yt-player', ytp);
          delete window.__ytbg_index[k];
        }
      };
      if (window.hasOwnProperty('YT') && window.YT.loaded) {
        window.onYouTubeIframeAPIReady();
      }
      return $this;
    };
  })(jQuery);
  init();
  return api;
};